import React from "react";
import { useMediaQuery, mediaQueriesNumbers } from "./mediaQueries"
import { default as fonts } from "./fonts"
import { colors } from "./colors"
import { mediaQueries } from "./mediaQueries";
import { LanguageSelector } from "./frames";

interface StyleSheet { 
  [key: string]: React.CSSProperties;
}

const mobile = window.innerWidth <= 1000;
const mobileXs = window.innerWidth <= 450;

const styles: StyleSheet = {     
  placeholderstyles: {
    "::placeholder": {
      color: "red"
    }
  } as React.CSSProperties,
  
  defBg: {
    zIndex: "1",
    width: "100%",
    position: "absolute",
    bottom: "0",
  } as React.CSSProperties,

  // "h1", header for container content and modal header  
  topHeader: {
    ...fonts.header,
    ...fonts.textShadow,
    ...fonts.fontSize0,
    color: colors.greyLightTertiary,
  } as React.CSSProperties,

  // "h2", subheader for container content
  subHeader: {
    ...fonts.header,
    ...fonts.textShadow,
    ...fonts.fontSize3,
    color: colors.greyLightTertiary,
  } as React.CSSProperties,

  emptyPen: {
    ...fonts.paragraph,
    ...fonts.fontSize4,
    fontStyle: "italic",
    color: colors.greyDarkPrimary,
  } as React.CSSProperties,

  unitsFontstyle:{
    ...fonts.header,
    ...fonts.fontSize4,
    color: colors.greyPrimary
  } as React.CSSProperties,

  // Specifik textStyles
  progressBarLabel:{
    margin: "0", 
    display: "flex", 
    alignItems: "center",
    height: "100%",
    ...fonts.header, 
    ...fonts.textShadow, 
    ...fonts.fontSize5, 
    color: colors.whitePrimary,
  } as React.CSSProperties,
  progressBarText:{
    margin: "0", 
    display: "flex", 
    alignItems: "center",
    height: "30px",
    ...fonts.paragraph, 
    ...fonts.fontSize4,
    color: colors.greyDarkPrimary,
  } as React.CSSProperties,
  colorTag:{
    padding: "4px 5px", 
    width: "fit-content", 
    borderRadius: "6px",
  } as React.CSSProperties,
  backdropFilter:{
    position: "absolute", 
    width: "100%", 
    height: "100%", 
    backgroundColor: "black", 
    opacity: "0.5",
    top: "0", 
    left: "0"
  } as React.CSSProperties,
  // ---------------------------------------------------
  // #endregion

  // #region | Table grids
  grid_twoRows_top: {
    backgroundColor: colors.greyPrimary, 
    display: "flex", 
    flexDirection: "column", 
    alignItems: "start", 
    justifyContent: "end", 
    gap: "10px", 
    padding: "10px"
  } as React.CSSProperties,
  grid_twoRows_content: {
    border: "5px solid", 
    borderColor: colors.greyPrimary,
    backgroundColor: colors.greyLightTertiary, 
    overflowY: "auto"
  } as React.CSSProperties,

  // ---------------------------------------------------
  // #endregion

  // #region | Button
  button_FitContent: {
    width: "fit-content",
    height: "fit-content",
    padding: "4px 6px"
  } as React.CSSProperties,
  button_TextUnderline: {
    textDecoration: "underline",
    textDecorationColor: colors.greyLightTertiary,
    textUnderlineOffset: "5px"
  } as React.CSSProperties,
  button_PositionStartEnhancerStart: {
    position: "absolute", 
    top: "50%", 
    left: "10px", 
    transform: "translate(0%, -50%)"
  } as React.CSSProperties,
    // ---------------------------------------------------
  // #endregion

  // #region | NavLink
  navLink_baseStyles: {
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    justifyContent: "center",
    borderRadius: "10px",
    backgroundColor: colors.transparent,
    cursor: "pointer"
  } as React.CSSProperties,
  navLink_hoverStyles: {
    backgroundColor: colors.blueDarkPrimary,
  } as React.CSSProperties,
  navLink_contentStyles: {
    ...fonts.header,
    ...fonts.textShadow,
    // ...fonts.fontSize4,
    color: colors.greyLightTertiary,
    cursor: "pointer",
    textAlign: "center"
  } as React.CSSProperties,
  navLink_childrenStyles: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "start",
    gap: "10px"
  } as React.CSSProperties,
  // ---------------------------------------------------
  // #endregion

  // #region | Language Selector
  languageSelector_primary: {
    color: colors.greyLightTertiary,
    backgroundColor: colors.greyDarkPrimary
  } as React.CSSProperties,

  languageSelector_secondary: {
    backgroundColor: colors.transparent,
  } as React.CSSProperties,

  LanguageSelector_seperator: {
    borderColor: colors.greyDarkSecondary,
    borderStyle: "solid",
    borderWidth: "0px 2px 0px 0px",
    height: "20px"
  } as React.CSSProperties,
  // ---------------------------------------------------
  // #endregion

  // #region | Modals
  modal: {
    backgroundColor: colors.blueDarkPrimary,
    margin: "0px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    maxHeight: "90vh",
    overflow: "hidden",
    maxWidth: mobile? "90vw" : "undefined",
    boxSizing: "border-box"
  } as React.CSSProperties,
  modalInner_primary: {
    margin: "0", 
    padding: "0", 
    borderRadius: "0px 0px 10px 10px",
    maxHeight: "70vh",

  } as React.CSSProperties,
  modalInner_secondary: {
    margin: "0", 
    padding: "0", 
    borderRadius: "0px 0px 10px 10px",
    maxHeight: "70vh", 
    boxSizing: "border-box",
    // overflowX: "hidden",
    scrollbarColor: `${colors.greyLightSecondary} transparent`,
    scrollbarWidth: "thin",
  } as React.CSSProperties,
  modal_primary: {
    padding: mobile? "30px 20px" : "60px",
    // maxWidth: mobile? "80vw" : "undefined",
  } as React.CSSProperties,
  modal_secondary: {
    padding: "40px 5px 5px 5px",
  } as React.CSSProperties,
  MaskToggleIcon: {
    width: "30px",
    transition: "0.1s",
    cursor: "pointer"
  } as React.CSSProperties,
  inputFieldEnhancer: {
    width: "25px",
    transition: "0.1s",
  } as React.CSSProperties,
  // ---------------------------------------------------
  // #endregion

  // #region | Freeda Location feeder
  modalTop: {
    display: "flex", 
    flexDirection: "row", 
    alignItems: "flex-end", 
    justifyContent: "center", 
    gap: "40px",
    width: "735px",
    height: "170px"
  } as React.CSSProperties,
  feedCorrectionBtn: {
    backgroundColor: colors.greyDarkPrimary, 
    display: "flex", 
    alignItems: "center", 
    justifyContent: "center",
    cursor: "pointer",
  } as React.CSSProperties,
  penHeaders: {
    ...fonts.header, 
    ...fonts.fontSize4, 
    color: colors.greyPrimary,
    paddingBottom: "2px"
  } as React.CSSProperties,
  penHeadersIndividual: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%",
    color: colors.greyDarkSecondary,
    ...fonts.fontWeight2,
    ...fonts.fontSize4
  } as React.CSSProperties,
  seperatorLine: {
    width: "735px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "20px auto",
    borderWidth: "0px 0px 2px 0px",
    borderColor: colors.greyTertiary,
    borderStyle: "solid"
  } as React.CSSProperties,
  // ---------------------------------------------------
  // #endregion

  // #region | TableList, TableStyles
  tableList_root: {
    height: "100%",
    width: "100%",
    borderRadius: "10px",
  } as React.CSSProperties,

  tableStyle: {
    maxHeight: "100%",
    height: "fit-content",
    backgroundColor: colors.transparent,
    boxShadow: "none",
    border: "none",
    borderRadius: "0px",
    overflow: "auto",
    scrollbarColor: colors.greySecondary + colors.greyPrimary,
    scrollbarWidth: "thin",
    cursor: "default",
    position: "relative",
  } as React.CSSProperties,
  headCellStyle: {
    boxShadow: "none",
    backgroundColor: colors.greyPrimary,
    alignItems: "center",
    padding: "2px 0px 2px 16px",
    border: "none",
    ...fonts.header,
    ...fonts.fontSize3,
    cursor: "default",
    height: "30px",
    boxSizing: "border-box",
    color: colors.greyLightTertiary
  } as React.CSSProperties,
  bodyCellStyle: {
    minWidth: "100px",
    height: "40px",
    padding: "0px 16px",
    color: colors.blackPrimary,
    alignContent: "center",
    ...fonts.paragraph,
    ...fonts.fontSize4,
    cursor: "default"
  } as React.CSSProperties,
  bottomCellStyle: {
    height: "22px",
    backgroundColor: colors.greyPrimary,
    padding: "2px 0px 2px 16px",
    border: "none",
    alignItems: "center",
    boxShadow: "none",
    position: "sticky",
    bottom: "0",
    zIndex: "2",
    ...fonts.header,
    ...fonts.fontSize3,
    cursor: "default"
  } as React.CSSProperties,
  pinningBorderStyle: {
    border: "2px solid "+colors.greySecondary
  } as React.CSSProperties,
  span: {
    "::[title]:hover:after": {
        padding: "40px"
    }
  } as React.CSSProperties,
  // ---------------------------------------------------
  // #endregion

  // #region | FeedCurve
  infobox: {
    width: "170px",
    // height: "237px",
    height: "150px",
    padding: "10px", 
    borderRadius: "10px", 
    backgroundColor: colors.greyDarkPrimary, 
    display: "flex", 
    flexDirection: "column", 
    gap: "10px", 
    overflowY: "scroll",
    scrollbarWidth: "thin",
    scrollbarColor: colors.greyDarkSecondary+colors.transparent
  } as React.CSSProperties,
  // ---------------------------------------------------
  // #endregion

  // #region | Animals&Animal
  basic_Info_style:{
    color: colors.greyLightTertiary, 
    display: "grid",
    gridTemplateRows: "1fr", 
    columnGap: "5px",
    ...fonts.paragraph
  } as React.CSSProperties,
  basicInfo_rightStyle: {
    display: "flex",
    justifyContent: "right",
    alignItems: "center",
    textAlign: "right"
  } as React.CSSProperties,
  basicInfo_centerStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as React.CSSProperties,
  basicInfo_leftStyle: {
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
  } as React.CSSProperties,
  // ---------------------------------------------------
  // #endregion

  page_inner_content_overflow_scroll: {
    height: "100%", 
    width: "100%", 
    overflowY: "scroll",     
    scrollbarColor: colors.greyDarkPrimary + colors.transparent,
    scrollbarWidth: "thin"
  } as React.CSSProperties,

  listStyle_vertical: {
    display: "flex", 
    flexDirection: "column"
  } as React.CSSProperties,
  listStyle_group: { 
    display: "flex", 
    flexWrap: "wrap",  
    justifyContent: "start",
  } as React.CSSProperties,
  listStyle_centeredGroup: { 
    display: "flex", 
    flexWrap: "wrap",  
    justifyContent: "center",
  } as React.CSSProperties,
  listStyle_horizontal: {
    display: "flex",
    flexDirection: "row",
    // flexWrap: "wrap",
  } as React.CSSProperties,

  rightContentOuter: {
    display: "flex",
    flexDirection: "column",
    flexShrink: "0",
    padding: "0px 20px",
    boxSizing: "border-box",
    height: "250px"
  } as React.CSSProperties,
  rightContent: {
    padding: "10px",
    display: "flex",
    flexShrink: "0",
    flexDirection: "column",
    gap: "10px",
    overflowY: "auto",
    boxSizing: "border-box",
    scrollbarWidth: "thin",
    scrollbarColor: colors.greySecondary + colors.transparent,
  } as React.CSSProperties,
  rightContentTop: {
    height: "40px",
    flexShrink: "0",
    width: "100%",
    display: "flex",
    alignItems: "end",
    justifyContent: "center",
    position: "relative",
    padding: "5px",
    boxSizing: "border-box"
  } as React.CSSProperties,
    rightContentSeperator: {
      backgroundColor: colors.greySecondary,
      width: "100%",
      height: "2px",
      flexShrink: "0",
  } as React.CSSProperties,

  systemOverviewGrid_container1: {
    flexDirection: "column",
    gap: "20px",
    overflowY: "auto",
    overflowX: "hidden",
    scrollbarColor: colors.greyDarkPrimary + colors.transparent,
    scrollbarWidth: "thin",
    display: "flex"
  } as React.CSSProperties,
  systemOverviewGrid_container2: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    alignItems: "center",
    width: "100%"
  } as React.CSSProperties,

  // #region | ToolsPanel

  // ---------------------------------------------------
  // #endregion
}

export default styles